import { render } from "./navigation-tiers.vue?vue&type=template&id=4c810070"
import script from "./navigation-tiers.vue?vue&type=script&lang=js"
export * from "./navigation-tiers.vue?vue&type=script&lang=js"

import "./navigation-tiers.vue?vue&type=style&index=0&id=4c810070&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__